module.exports = __webpack_public_path__ + "static/step3-3065b7223511f7cceea99eddebac4ddf.png";